module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAE2SURBVDiNzdPBccIwEAXQ/6VFuboD3EFowRUk6QAqyFABoQImFUAHPnGGDpJ04BLIMZalzcEwGA/EEMhM9mh/P+/uSMB/LwLAsmeHIPvXQKr89N4vuMXmN2rw3ShMciMMUKS7kecgh1diG4CZXTqZlDa82sgE5OAaDIjPAtXURbsqbchcsLi40wYGcij1U/4ObWEAIPu3F6JHMAAwhyEmEu2g9GEM1UU3BrT33gC1AJgZ8N45+1baMD2KHnQWcyhHVKxboBalCRmoDwBeGuO30Pqn+zGZgjH/stVolxOQRWmqzAU7AdHYW41G5ajy1VRE0kpC4SJnAB/bOcA8AVowBxLnZAXg9BlUbOpvcfpWbVchrmdnP2JdUDOjujIK89EZPreIQrz3i7ue9GNXl2d5HN+ms7+sbyoVkkszlM8yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Message.png
// module id = Ihw2
// module chunks = 1